export function processingStatusText(stage: string | null | undefined): {
  api: string;
  detail: string;
  isAiStage: boolean;
} {
  switch (stage) {
    case 'queued':
      return { api: 'กำลังรอคิว', detail: 'กำลังรอเริ่มอ่านเอกสาร', isAiStage: false };
    case 'uploading':
      return { api: 'กำลังเตรียมไฟล์', detail: 'กำลังเตรียมหน้าเอกสารสำหรับ OCR', isAiStage: false };
    case 'google_vision_ocr':
    case 'ocr_pages':
      return { api: 'Google Vision OCR', detail: 'กำลังอ่านข้อความจากเอกสาร', isAiStage: false };
    case 'gemini_vision_fallback':
      return {
        api: 'Gemini Vision (สำรอง)',
        detail: 'Google Vision อ่านข้อความไม่พบ กำลังให้ Gemini อ่านภาพแทน',
        isAiStage: false,
      };
    case 'gemini_mapping':
      return {
        api: 'Gemini 2.5 Flash-Lite',
        detail: 'กำลังสรุปและจัดข้อมูลลงในช่องที่เกี่ยวข้อง',
        isAiStage: true,
      };
    case 'ai_mapping':
      return { api: 'AI Mapping', detail: 'กำลังวิเคราะห์และจัดข้อมูลเอกสาร', isAiStage: true };
    case 'failed':
      return { api: 'ไม่สามารถดำเนินการได้', detail: 'การประมวลผลเอกสารไม่สำเร็จ', isAiStage: false };
    default:
      return { api: 'กำลังเตรียมระบบ', detail: 'กำลังเริ่มประมวลผลเอกสาร', isAiStage: false };
  }
}
